import { StringUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { ContainerElement } from "./ContainerElement";
import { ParticleElement, ParticleElementAttributes } from "./ParticleElement";
import { ParticleAnimationElement } from "./ParticleAnimationElement";

@engineComponent(ComponentTypes.DisplayObject)
// TODO add comments
export class ParticleGroupElement extends ContainerElement {
    static DynamicKey: string = "";

    private _emitOnce: boolean;
    private _startType: string;

    constructor() {
        super();

        this._emitOnce = false;
        this._startType = "";
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        this.visible = false;
    }

    updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.hasAttribute(ParticleElementAttributes.EMIT_ONCE)) {
            this._emitOnce = StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.EMIT_ONCE));
        }

        if (node.hasAttribute(ParticleElementAttributes.START_TYPE)) {
            this._startType = node.getAttribute(ParticleElementAttributes.START_TYPE);
        }

        if (
            node.hasAttribute(ParticleElementAttributes.START) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.START))
        ) {
            if (StringUtils.isNullOrEmpty(ParticleGroupElement.DynamicKey)) {
                this.start(this._emitOnce);
            } else {
                this.startSelected(this._emitOnce, ParticleGroupElement.DynamicKey);
            }
        }

        if (
            node.hasAttribute(ParticleElementAttributes.STOPPING) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOPPING))
        ) {
            this.stopping();
        }

        if (
            node.hasAttribute(ParticleElementAttributes.STOP) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOP))
        ) {
            this.stop();
        }

        if (
            node.hasAttribute(ParticleElementAttributes.RESET) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.RESET))
        ) {
            if (StringUtils.isNullOrEmpty(ParticleGroupElement.DynamicKey)) {
                this.reset();
            } else {
                this.resetSelected(ParticleGroupElement.DynamicKey);
            }
        }

        if (
            node.hasAttribute(ParticleElementAttributes.CLEAR) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.CLEAR))
        ) {
            this.clear();
        }
    }

    start(emitOnce: boolean = false): void {
        this._emitOnce = emitOnce;
        this.visible = true;
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                    this.childs[key].start(this._emitOnce, this._startType);
                }
            }
        }
    }

    startSelected(emitOnce: boolean = false, particleKey: string): void {
        if (!StringUtils.isNullOrEmpty(particleKey)) {
            this._emitOnce = emitOnce;
            this.visible = true;

            if (this.childs != null) {
                for (let key in this.childs) {
                    if (key.indexOf(particleKey) > -1) {
                        if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                            this.childs[key].start(this._emitOnce, this._startType);
                        }
                    }
                }
            }
        }
    }

    stopping(): void {
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                    this.childs[key].stopping();
                }
            }
        }
    }

    stop(): void {
        this.visible = false;
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                    this.childs[key].stop();
                }
            }
        }
    }

    reset(): void {
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                    this.childs[key].reset();
                }
            }
        }
    }

    resetSelected(particleKey: string): void {
        if (!StringUtils.isNullOrEmpty(particleKey)) {
            if (this.childs != null) {
                for (let key in this.childs) {
                    if (key.indexOf(particleKey) > -1) {
                        if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                            this.childs[key].reset();
                        }
                    }
                }
            }
        }
    }

    clear(): void {
        this.visible = false;
        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof ParticleElement || ParticleAnimationElement) {
                    this.childs[key].clear();
                }
            }
        }
    }

    /*clone(): ParticleGroupElement
    {
        let element: ParticleGroupElement = <ParticleGroupElement>super.clone();
        element._emitOnce = this._emitOnce;
        element._startType = this._startType;

        element.markAsCloned(); // must be called last before return!
        return element;
    }*/

    clone(): ParticleGroupElement {
        let element: ParticleGroupElement = new ParticleGroupElement();

        element.style = this.style;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        element.name = this.name;
        element._emitOnce = this._emitOnce;
        element._startType = this._startType;

        element.childs = {};
        element.removeChildren();
        for (let key in this.childs) {
            element.childs[key] = this.childs[key].clone();
            element.addChild(element.childs[key]);
        }

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        }

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Graphics/ParticleGroupElement.ts
 **/